/* eslint-disable no-unused-vars */
import { TimeEntryErrorModel } from './timeEntryErrorModel'
import ResultDTO from '@/models/app/resultDTO'
import TimeEntryAPIErrorContext from '@/constants/booking/timeEntries/TimeEntryAPIErrorContext'
import ErrorResponseDTO from '@/models/error/errorResponseDTO'

export class TimeEntryMealBreakStatusErrorModel extends TimeEntryErrorModel {
  /** @param {ResultDTO<ErrorResponseDTO>} errorResponse */
  constructor(errorResponse) {
    super(errorResponse, TimeEntryAPIErrorContext.mealBreakStatus)

    /**
     * See {@link https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_wiki/wikis/anzuk%20Dev%20Team/366/Ready2Work-2.0?anchor=get-/api/v1.0/time-entries/meal-break/status Error Code Wiki}
     * @type {string[]}
     */
    this.errorCodesToRefresh = [
      'no_available_shifts',
      'meal_break_not_started',
      'already_clocked_out',
      'already_ended_meal_break',
      'security_error',
      'auto_clocked_out',
      'booking_in_future',
      'booking_not_found',
    ]
  }

  /** @override */
  shouldTriggerTimeEntryStatusRefresh() {
    return this.errorCodesToRefresh.includes(this.errorCode)
  }
}
